import {Component, ElementRef, OnInit, ViewChild} from '@angular/core';
import {ModalService} from "../../services/modal.service";
import {Subject} from "rxjs/Subject";
import {APP_MESSAGES} from "../../enums/enums";
import {IDocument} from "../../interfaces/document.definition";
import {isUndefined} from "util";
import {JP} from "../../helpers/jp";
import {WatchService} from "../../services/watch.service";

declare const $: any;

@Component({
  selector: 'nv-fmanager-modal',
  templateUrl: './nv-fmanager-modal.component.html',
  styles: []
})
export class NvFmanagerModalComponent implements OnInit {

  @ViewChild("modalRoot") element: ElementRef;
  @ViewChild("iframe") iframeElt: ElementRef;

  private _pointer:string;
  private _document:IDocument;
  private unsubscribe: Subject<void> = new Subject<void>();

  get document():IDocument {
    return this._document;
  }

  constructor(private modalService: ModalService, private watchService:WatchService) { }

  ngOnInit() {
    this.modalService
      .onModalRequest
      .takeUntil(this.unsubscribe)
      .filter(
        appMessage => appMessage.type === APP_MESSAGES.POPUP_FMANAGER_MODAL)
      .subscribe( appMessage => {
        this._pointer = appMessage.content.pointer;
        this.show(appMessage.content.document);
      });
    this.iframeElt.nativeElement.contentWindow.addEventListener("childchange", this.onChange)
  }

  onChange(){
    console.log("fmanager change");
  }

  ngOnDestroy(): void {
    this.unsubscribe.next();
    this.unsubscribe.complete();
  }

  onPickFile():void {
    console.log(`pick ${this.getCurrentPath()}`);
    JP.set(this.document, this._pointer, this.getCurrentPath());
    this.watchService.notify();
    $(this.element.nativeElement).modal("hide");
  }

  isFileSelected():boolean {
    let path:String = this.getCurrentPath();
    return !isUndefined(path) && path.indexOf(".") > 0;
  }

  private getCurrentPath():string {
    var w:any = this.iframeElt.nativeElement.contentWindow;
    return w.fmanagerPath ? w.fmanagerPath.substring(1) : "";
  }

  private show(document:IDocument) {
    this._document = document;
    $(this.element.nativeElement).modal();
  }
}



// WEBPACK FOOTER //
// /opt/app/develop/src/app/modals/nv-fmanager-modal/nv-fmanager-modal.component.ts